var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.0001 7.4001L0.600098 2.0001L2.0001 0.600098L6.0001 4.6001L10.0001 0.600098L11.4001 2.0001L6.0001 7.4001Z","fill":"#112A38"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }